// Components
import maTooltip from '../tooltip'
import maInputText from '@/components/input/modules/text'

/**
 * Component that includes an input and two buttons to add or sustract 1 from
 * the value of the input.
 */
export default {
  name: 'counter',
  components: {
    maTooltip,
    maInputText
  },

  /**
   * @property {Number} modifiedValue Where the modifications of the value will
   * be registered.
   */
  data: function () {
    return {
      modifiedValue: this.value
    }
  },
  /**
   * @property {String} classColumn Returns the class that gives the container the number of columns it will occupy
   */
  /**
   * @property {String} isDisabledClass Returns the class disabled or undifined for the button based on a condition
   */
  computed: {
    classColumn () {
      const marginColumnClass = this.noMargin ? '' : 'mg mg--r-2'
      return `${marginColumnClass} grid__cell-md-${this.col || '1'}`
    },
    isDisabledClass () {
      const intValue = parseInt(this.value)
      const threshold = this.canReturnToZero ? 0 : 1
      return threshold >= intValue ? 'disabled' : 'undefined'
    },
    buttonFullSize() {
      if (!this.fullSize) {
        return {}
      }

      return {
        height: '40px',
        width: '40px'
      }
    },
    inputFullSize() {
      if (!this.fullSize) {
        return {}
      }

      return {
        height: '40px'
      }
    }
  },

  /**
   * @property {Number} value number passed to the component.
   * @property {String} label Label of the component if one.
   */
  props: {
    value: {
      type: Number | String,
      required: true
    },
    literal: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    showTooltip: {
      type: Boolean,
      required: false
    },
    textTooltip: {
      type: String,
      required: false
    },
    noMargin: {
      type: Boolean,
      required: false,
      default: false
    },
    fullSize: {
      type: Boolean,
      required: false,
      default: false
    },
    canReturnToZero: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    /**
     * Method to add one to the value and emit an event with the new value.
     */
    handleAdd () {
      this.modifiedValue = this.value
      ++this.modifiedValue
      this.emitNewValue(this.modifiedValue)
    },

    /**
     * Method to sustract one to the value and emit an event with the new
     * value.
     */
    handleSustract () {
      this.modifiedValue = this.value
      --this.modifiedValue
      this.emitNewValue(this.modifiedValue)
    },

    /**
     * Method that receives a value from the input update and modifies
     * accordingly the data 'modifiedValue'.
     */
    handleUpdateInput (v) {
      this.modifiedValue = v
      if (isNaN(v)) this.modifiedValue = 0
      this.emitNewValue(this.modifiedValue)
    },

    /**
     * Method that receives a value and emit an event to the father with the new
     * value.
     */
    emitNewValue () {
      const threshold = this.canReturnToZero ? 0 : 1
      if (this.modifiedValue >= threshold) this.$emit('newValue', this.modifiedValue)
    }
  }
}
